import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";

import {
  NextMeetingOfLeaderReminderQueryQuery,
  NextMeetingsOfParentReminderQueryQuery,
  PickLearnerQuery,
  PickLearnerQueryVariables,
} from "../../shared/generated/graphql";

const NextMeetingOfLeaderQuery = gql`
  query NextMeetingOfLeaderReminderQuery {
    nextMeetingOfLeaderReminder {
      uid
      startTime
      sectionUid
      activityTitle
    }
  }
`;

const NextMeetingsOfParentQuery = gql`
  query NextMeetingsOfParentReminderQuery {
    nextMeetingsOfParentReminder {
      uid
      startTime
      sectionUid
      activity {
        uid
        title
        titleTranslated
        details {
          photo
        }
        leader {
          name
          photo
        }
      }
      learnerUid
      canManage
    }
  }
`;

export function useNextMeetingOfLeaderReminder(skip: boolean) {
  return useQueryWithPreviousData<NextMeetingOfLeaderReminderQueryQuery>(
    NextMeetingOfLeaderQuery,
    {
      skip,
      pollInterval: skip ? 0 : 5 * 60 * 1000,
    },
  );
}

export function useNextMeetingsOfParentReminder(skip: boolean) {
  return useQueryWithPreviousData<NextMeetingsOfParentReminderQueryQuery>(
    NextMeetingsOfParentQuery,
    {
      skip,
      pollInterval: skip ? 0 : 5 * 60 * 1000,
    },
  );
}

export const classroomPickLearnerQuery = gql`
  query PickLearner($sectionUid: ID!) {
    classroom(sectionUid: $sectionUid) {
      uid
      section {
        uid
        currentUserCanManage
      }
    }
    learnersToPick(sectionUid: $sectionUid) {
      uid
      name
      age
      enrollmentUid
      isEnrollmentPaused
    }
  }
`;

export function usePickLearner(sectionUid: string) {
  return useQueryWithPreviousData<PickLearnerQuery, PickLearnerQueryVariables>(
    classroomPickLearnerQuery,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        sectionUid,
      },
    },
  );
}
